// Import necessary components and styles
import React from "react";
import { Link } from "react-router-dom";
import ProfilePicture from "./ProfilePicture";
import { formatTimestampForPost } from "../lib/formatTimestampForPost";
import AddOrRemoveSaved from "../Products/AddOrRemoveSaved";
import AddOrRemoveSavedList from "../ShoppingList/AddOrRemoveSavedList";

export default function UserDisplay2({ userData, post, componentName }) {
  // Check if userData is defined before accessing properties
  if (!userData) {
    return null; // or return a loading state/component
  }

  // console.log("Post in userDisplay", post);
  return (
    <div className="d-flex align-items-center w-100 ">
      {/* Avatar */}
      <div
        className="avatar card-title m-0 me-1"
        style={{ height: "50px", width: "50px" }}
      >
        <Link to={`/userProfile/${userData.userId}`}>
          <ProfilePicture
            userData={userData}
            className="avatar-img rounded-2"
          />
        </Link>
      </div>
      {/* Info */}
      <div
        className={`nav nav-divider d-flex ${
          componentName === "textPost" ? "flex-column" : "align-items-center"
        } justify-content-between w-100   py-1 m-0 rounded-2 px-2`}
      >
    
          <div style={{ fontFamily:'Inter'}}>
            <div className="m-0 text-truncate"style={{ fontWeight: 600, fontSize: '18px', color: '#000000',maxWidth: '400px' }}>
              {post?.title || post?.listName}</div>
            <div className="nav-item  mb-0">
              <Link
                className=""
                to={`/userProfile/${userData.userId}`}
              >
                <span style={{ fontWeight: 400, fontSize: '14px', color: '#676A79' }}>By {' '}
              
                  {userData.userName
                    ? userData.userName
                        .split(" ")
                        .slice(0, 2)
                        .map(
                          (word) => word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ")
                    : ""}
              </span>
              </Link>
            </div>
          </div>
        
        <div className="d-inline-flex pe-3 align-items-center justify-content-center rounded-pill text-light position-absolute end-0 top-0">
              {/* <span>
                <AddOrRemoveSavedList post={post} user={userData} />
              </span> */}
            </div>
        {/* <span className="small"> 12-12-2024</span> */}
        <span className="small pe-2 mt-0">
          {" "}
          {formatTimestampForPost(post?.dateCreated)}
        </span>
      </div>
      {/* <p className="mb-0 small">
      {userData.userTitle ? userData.userTitle : `Member since ${formatTimestamp(userData.timestamp)}`}
    </p> */}
    </div>
  );
}
